import { useCallback, useContext, useEffect, useState } from "react";
import PrimaryButton from "../../UI/PrimaryButton/PrimaryButton";
import Loader from "../../UI/Loader/Loader";
import FilterTab from "../../UI/FilterTab/FilterTab";
import ToggleDrawerButton from "../../UI/ToggleDrawerButton/ToggleDrawerButton";
import Order from "./Order/Order";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchAllOrders } from "../../../redux/order";
import { AuthContext } from "../../../context/authContext";
import GetStarted from "../../../assets/svg/get-started.svg";
import classes from "./Orders.module.scss";

const ORDERTYPES = [
  "ALL_ORDERS",
  "ORDER_ON_HOLD",
  "RESERVED",
  "COMPLETED",
  "VOIDED",
];

const Orders = () => {
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  const { selectedLocation } = useSelector((state) => state.location);
  const { orders, error, isLoading } = useSelector((state) => state.order);
  const dispatch = useDispatch();

  const [selectedOrderType, setSelectedOrderType] = useState("ALL_ORDERS");

  const onChangeFilter = useCallback((newValue) => {
    setSelectedOrderType(newValue);
  }, []);

  useEffect(() => {
    if (token && selectedLocation !== null) {
      dispatch(fetchAllOrders());
    }
  }, [dispatch, token, selectedLocation]);

  let allOrders = null;
  let filterTab = null;
  let noOrdersMessage = null;
  let noRestaurantSelected = null;
  let spinner = null;
  let errorMessage = null;
  let ordersStyleClasses = classes.NoOrders;

  if (orders && orders.length > 0) {
    ordersStyleClasses = classes.AllOrders;

    allOrders = orders
      .filter((order) => {
        if (selectedOrderType === "ALL_ORDERS") {
          return true;
        }
        if (selectedOrderType === "ORDER_ON_HOLD") {
          return order.status === "draft";
        }
        if (selectedOrderType === "RESERVED") {
          return false;
        }
        if (selectedOrderType === "COMPLETED") {
          return order.status === "complete";
        }
        if (selectedOrderType === "VOIDED") {
          return order.status === "cancel";
        }
        return true;
      })
      .map((order) => {
        return (
          <Order
            key={order.created_at}
            id={order.id}
            num={order.order_no}
            type={order.order_type}
            status={order.status}
            createdAt={order.created_at}
          />
        );
      });
    filterTab = (
      <FilterTab
        group="orderType"
        options={ORDERTYPES}
        selectedOption={selectedOrderType}
        onChangeFilter={onChangeFilter}
      />
    );
  }

  if (!error && isLoading) {
    spinner = <Loader />;
  }
  if (!isLoading && token && orders && orders.length === 0) {
    noOrdersMessage = (
      <div className={classes.GetStarted}>
        <img src={GetStarted} alt="" />
        <strong>Get Started!</strong>
        <p>Click on the button at the top right corner to create an order</p>
      </div>
    );
  }

  if (!token && !error) {
    noRestaurantSelected = <h3>Please select a restaurant.</h3>;
  }

  if (error) {
    errorMessage = <p className={classes.Error}>{error}</p>;
  }

  return (
    <div className={classes.Orders}>
      <div className={classes.HeaderTab}>
        <ToggleDrawerButton />
        {filterTab}
        <div className="ml-auto">
          <PrimaryButton
            text="New Order"
            onClicked={() => navigate("/home/new-order")}
          />
        </div>
      </div>
      <div className={ordersStyleClasses}>
        {allOrders}
        {noRestaurantSelected}
        {spinner}
        {noOrdersMessage}
        {errorMessage}
      </div>
    </div>
  );
};

export default Orders;
